import { configureStore } from "@reduxjs/toolkit";
import selectedTableReducer from "./slices/selectedTableSlice";
import csrDataReducer from "./slices/csrDataSlice";

export const store = configureStore({
  reducer: {
    selectedTable: selectedTableReducer,
    csrData: csrDataReducer,
  },
  devTools: true,
});
